const loadScript = (source) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    const prior = document.getElementsByTagName('script')[0]

    script.async = true
    script.defer = true

    const onloadHandler = (_, isAbort) => {
      if (
        isAbort ||
        !script.readyState ||
        /loaded|complete/.test(script.readyState)
      ) {
        script.onload = null
        script.onreadystatechange = null

        if (isAbort) {
          reject()
        } else {
          resolve()
        }
      }
    }

    script.onload = onloadHandler
    script.onreadystatechange = onloadHandler

    script.src = source
    prior.parentNode.insertBefore(script, prior)
  })
}

export default loadScript
